import React from 'react';
import { Row } from 'react-bootstrap';

const RowView = ({ 
    children, 
    isMobile = false, 
    isTablet = false, 
    isDesktop = false, 
    xs, 
    sm, 
    md, 
    lg, 
    xl, 
    style, 
    className,
    ...props 
}) => {
    return (
        <Row xs={xs} sm={sm} md={md} lg={lg} xl={xl} className={className} style={style} {...props}>
            {children}
        </Row>
    );
};

export default RowView;
